/**
 * @file Which version and commit this bundle was built from. Consumed by
 * `config.ts` for the launch log and by `providers/PosthogProvider.tsx`, which
 * registers it on every event.
 *
 * `vite.config.mts` substitutes `__BUILD_INFO__` at bundle time from
 * `resolveBuildVersion`, so this costs nothing at runtime and cannot be wrong
 * about the tree it came from. The version is `MAJOR.MINOR.<commit count>`, and
 * a count identifies a commit only on one line of history — the sha is what
 * makes a support log point at bytes. Outside a vite build the identifier is
 * genuinely undeclared, hence `typeof`: the one way to ask about an undeclared
 * binding without throwing.
 */

type BuildInfo = { version: string; commit: string | null; dirty: boolean }

declare const __BUILD_INFO__: BuildInfo

export const buildInfo: BuildInfo =
    typeof __BUILD_INFO__ === 'undefined'
        ? { version: '0.0.0', commit: null, dirty: false }
        : __BUILD_INFO__;
